<div class="form-wrapper-80">
    <h2>Resources</h2>
    <form novalidate [formGroup]="resourcesEditForm">
        <div class="check-box-container">
            <input type="checkbox" formControlName="enableResources" id="enableResources" />
            <label for="enableResources">Enable resources?</label>
        </div>

        <div *ngIf="resourcesEditForm.get('enableResources').value">
            <div class="app-c-form-group">
                <label class="app-c-form--label" for="resources" translate>General info</label>
                <ckeditor [editor]="Editor" formControlName="resources" [config]="config" id="resources"></ckeditor>
            </div>

            <div id="ressourceSection" *ngIf="organization.resourceSet">
                <div class="resource-sets-header">
                    <h2>Resource Sets</h2>
                    <div class="app-c-form-group app-c-form-group--inline">
                        <label class="app-c-form--label" for="resourceLanguage">Language</label>
                        <mat-select id="resourceLanguage" class="app-c-form-control" name="language"
                            [(ngModel)]="Language" [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onSelectOrganization()">
                            <mat-option *ngFor="let lang of this.allLang" [value]="lang">{{ lang }}</mat-option>
                        </mat-select>
                    </div>
                </div>

                <datalist id="resourceCategoryOptions">
                    <mat-option *ngFor="let option of resourceSetOptions[Language]" [value]="option"></mat-option>
                </datalist>

                <div class="resource-set-list" cdkDropList (cdkDropListDropped)="drop($event)" formArrayName="resourceSet">
                    <ng-container *ngFor="let resource of resourceSet.controls; let i = index;">
                        <div *ngIf="showResourceByLanguage(resource)"
                            class="resource-set-card"
                            [class.resource-set-card--expanded]="isExpanded(i)"
                            id="resourceSet_{{i}}"
                            [formGroupName]="i"
                            cdkDrag
                            cdkDragLockAxis="y">
                            <div class="resource-set-card__placeholder" *cdkDragPlaceholder></div>

                            <button type="button"
                                class="resource-set-card__header"
                                id="resource_{{i}}"
                                (click)="toggleExpanded(i)">
                                <span class="resource-set-card__title">
                                    {{ resource.get('title').value || "New Resource Category" }}
                                </span>
                                <span class="resource-set-card__actions">
                                    <button type="button"
                                        class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20 delete-btn"
                                        (click)="onRemoveResourceset(i); $event.stopPropagation()" title="Remove category">
                                        <svg-icon icon="trash" class="w-100 h-100"></svg-icon>
                                    </button>
                                    <svg-icon icon="angle-down" class="resource-set-card__chevron"></svg-icon>
                                </span>
                            </button>

                            <div class="resource-set-card__body" *ngIf="isExpanded(i)">
                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" [for]="'setTitle_' + i">Resource Category Title</label>
                                    <input cdkFocusInitial class="app-c-form-control" type="text"
                                        [id]="'setTitle_' + i"
                                        list="resourceCategoryOptions"
                                        placeholder="e.g. Academic Resources"
                                        formControlName="title" />
                                    <p class="form-help-text">Choose a category from the list or create your own.</p>
                                    <div class="error-message"
                                        *ngIf="getResourceSetFormGroup(i).controls['title'].touched
                                            && getResourceSetFormGroup(i).controls['title'].errors?.required">
                                        Resource set needs a title.
                                    </div>
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" [for]="'setDescription_' + i">Description</label>
                                    <input class="app-c-form-control" type="text"
                                        [id]="'setDescription_' + i"
                                        formControlName="summary" />
                                </div>

                                <div class="resource-list-section">
                                    <div class="resource-list-header">
                                        <h3>Resource List ({{ getResourceGroup(i).controls.length }})</h3>
                                    </div>

                                    <ng-container formArrayName="resourcesetGroup">
                                        <p *ngIf="getResourceGroup(i).controls.length === 0" class="empty-state">
                                            Please add resources.
                                        </p>

                                        <table class="table" *ngIf="getResourceGroup(i).controls.length > 0">
                                            <tbody cdkDropList (cdkDropListDropped)="dropGroup($event, i)">
                                                <tr cdkDrag *ngFor="let resourcegp of getResourceGroup(i).controls; let j = index">
                                                    <div class="resource-row-placeholder" *cdkDragPlaceholder></div>
                                                    <td cdkDragLockAxis="y">
                                                        <p class="strong title">{{ resourcegp.value.title }}</p>
                                                        <div *ngIf="resourcegp.value.address" class="icon-text">
                                                            <svg-icon icon="lang-icon"></svg-icon>
                                                            <span>{{ resourcegp.value.address }}</span>
                                                        </div>
                                                        <div *ngIf="resourcegp.value.website" class="icon-text">
                                                            <svg-icon icon="web-icon"></svg-icon>
                                                            <a [href]="resourcegp.value.website" target="_blank">
                                                                <span>{{ resourcegp.value.website }}</span>
                                                            </a>
                                                        </div>
                                                        <div *ngIf="resourcegp.value.contact" class="icon-text">
                                                            <svg-icon icon="support-icon"></svg-icon>
                                                            <span>{{ resourcegp.value.contact }}</span>
                                                        </div>
                                                        <div *ngIf="resourcegp.value.alternateContact" class="icon-text">
                                                            <svg-icon icon="email-icon"></svg-icon>
                                                            <span>{{ resourcegp.value.alternateContact }}</span>
                                                        </div>
                                                        <p>{{ resourcegp.value.description }}</p>

                                                        <div [ngClass]="resourcegp.value.active === 1 ? 'active' : 'inactive'">
                                                            <p class="strong">
                                                                <img alt="Status" class="rounded" height="20"
                                                                    src="./assets/img/welltrack-boost-circle.png">
                                                                {{ resourcegp.value.active === 1 ? 'Active' : 'Inactive' }}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td class="action-btn">
                                                        <button class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                                                            (click)="editResourceGroup(resourcegp.value, resource.value, i, j)">
                                                            <svg-icon icon="edit"></svg-icon>
                                                            <span translate>practice.rfp.edit</span>
                                                        </button>
                                                    </td>
                                                    <td class="action-btn">
                                                        <button class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                                                            (click)="removeResourceGroup(resourcegp.value, resource.value, i, j)">
                                                            <svg-icon icon="trash"></svg-icon>
                                                            <span translate>practice.rfp.delete</span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <button type="button" class="app-c-btn app-c-btn--secondary app-c-btn--curve add-resource-btn"
                                            (click)="addResourceGroup(i, {}, 'add', resource.value, j)">
                                            Add Resource
                                        </button>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <button type="button" class="app-c-btn app-c-btn--primary app-c-btn--curve add-set-btn"
                    (click)="addRessourceSet({})">
                    Add Resource Set
                </button>
            </div>
        </div>
    </form>
</div>
